import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import "./createPost.css";

const CreatePost = () => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [media, setMedia] = useState(null);
  const navigate = useNavigate();

  const userRole = localStorage.getItem("userRole");

  if (userRole !== "admin") {
    return <h2>Access Denied. Admins Only.</h2>; // Prevent non-admins from seeing this page
  }

  const handleMediaChange = (e) => {
    setMedia(e.target.files[0]);
  };

  const handleCreatePost = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("content", content);
    if (media) {
      formData.append("media", media);
    }

    try {
      await axiosInstance.post("/posts", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("Post created successfully!");
      navigate("/"); // Redirect back to home after posting
    } catch (err) {
      alert("Error creating post");
    }
  };

  return (
    <div className="createPostContainer">
      <h2>Create a New Post</h2>
      <form onSubmit={handleCreatePost}>
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        <textarea
          placeholder="Content"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          required
        />
        <input type="file" accept="image/*, video/*" onChange={handleMediaChange} />
        <button type="submit">Create Post</button>
      </form>
    </div>
  );
};

export default CreatePost;
